import React, { useEffect, useState } from "react";
import "./AddInterview.css";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router";
import {
  getallcategory,
  addsubcategorylist,
  addfaqs,
  addvoucher,
} from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values) => {
  const errors = {};

  if (!values.code) {
    errors.code = "Required";
  }
  if (!values.discountType) {
    errors.discountType = "Required";
  }
  if (!values.discountValue) {
    errors.discountValue = "Required";
  }

  if (!values.minOrderValue) {
    errors.minOrderValue = "Required";
  }
  if (!values.expiryDate) {
    errors.expiryDate = "Required";
  }
  if (!values.usageLimit) {
    errors.usageLimit = "Required";
  }
  return errors;
};

const AddVoucher = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");
  const [cat, setcat] = useState([]);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      code: "",
      discountType: "",
      discountValue: "percentage",
      maxDiscount: "",
      minOrderValue: "",
      expiryDate: "",
      usageLimit: "",
      createdBy: "1",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });
  console.log(formik.errors);

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addvoucher(values);
      navigate("/Voucher_List");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Voucher</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Code</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="code"
              type="text"
              placeholder="code"
              minLength={1}
              maxLength={200}
              value={formik.values.code}
              className="Auth_input"
            />
            {formik.errors.code ? (
              <p className="invalid">{formik.errors.code} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Select Discount Type</label>
            <br />
            <select
              onChange={formik.handleChange}
              name="discountType"
              value={formik.values.discountType}
              className="Auth_input"
            >
              <option value="percentage">Percentage</option>
              <option value="flat">Flat</option>
            </select>
            {formik.errors.discountType ? (
              <p className="invalid">{formik.errors.code} </p>
            ) : null}
          </div>

          <div>
            <label className="Auth_label">
              {formik.values.discountType === "percentage"
                ? "Discount Value(%)"
                : "Flat Off (Rs)"}
            </label>
            <br />
            <input
              onChange={formik.handleChange}
              name="discountValue"
              placeholder="Value"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.discountValue}
              className="Auth_input"
            />
            {formik.errors.discountValue ? (
              <p className="invalid">{formik.errors.discountValue} </p>
            ) : null}
          </div>
          {formik.values.discountType === "percentage" && (
            <div>
              <label className="Auth_label">Max Discount</label>
              <br />
              <input
                onChange={formik.handleChange}
                name="maxDiscount"
                type="number"
                placeholder="Max Discount"
                minLength={1}
                maxLength={200}
                value={formik.values.maxDiscount}
                className="Auth_input"
              />
              {formik.errors.maxDiscount ? (
                <p className="invalid">{formik.errors.maxDiscount} </p>
              ) : null}
            </div>
          )}
          <div>
            <label className="Auth_label">Min Order</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="minOrderValue"
              placeholder="Min Order"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.minOrderValue}
              className="Auth_input"
            />
            {formik.errors.minOrderValue ? (
              <p className="invalid">{formik.errors.minOrderValue} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Expiry Date</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="expiryDate"
              type="date"
              value={formik.values.expiryDate}
              min={new Date().toISOString().split("T")[0]}
              className="Auth_input"
            />
            {formik.errors.expiryDate ? (
              <p className="invalid">{formik.errors.expiryDate} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Usage Limit</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="usageLimit"
              placeholder="Usage Limit"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.usageLimit}
              className="Auth_input"
            />
            {formik.errors.usageLimit ? (
              <p className="invalid">{formik.errors.usageLimit} </p>
            ) : null}
          </div>
          <div />
          <button className="term_button" type="Submit">
            {load ? "Adding..." : "Save"}
          </button>
        </form>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default AddVoucher;
